// extracted by mini-css-extract-plugin
export default {"trustCenter":"nk2eIh6xWPAZdVoezsaQ","banner":"bbxlP94fJuSwoz8GSLKJ"};